import { getClickText, getElementType, getLocation } from './elementMeta';
import { trackGAEvent, type GA4EventParams } from './ga4';

const INTERACTION_EVENT = 'website_interaction';

const DATA_TRACK_PREFIX = 'track';

function getInteractionType(el: HTMLElement): string {
  const role = el.getAttribute('role');
  if (role) return role;
  if (el.tagName.toLowerCase() === 'input') {
    return (el as HTMLInputElement).type || 'input';
  }
  return getElementType(el);
}

function isCustomParamKey(key: string): boolean {
  return (
    key.startsWith(DATA_TRACK_PREFIX) &&
    key.length > DATA_TRACK_PREFIX.length &&
    key[DATA_TRACK_PREFIX.length] === key[DATA_TRACK_PREFIX.length].toUpperCase()
  );
}

function datasetKeyToParam(key: string): string {
  const suffix = key.slice(DATA_TRACK_PREFIX.length);
  return suffix.charAt(0).toLowerCase() + suffix.slice(1);
}

function applyCustomParams(el: HTMLElement, params: GA4EventParams): void {
  for (const [key, value] of Object.entries(el.dataset)) {
    if (value != null && isCustomParamKey(key)) {
      params[datasetKeyToParam(key)] = value;
    }
  }
}

export function trackInteraction(el: HTMLElement): void {
  const moduleEl = el.closest<HTMLElement>('[data-module]');
  const trackEl = el.closest<HTMLElement>('[data-track]');

  const params: GA4EventParams = {
    interaction_type: getInteractionType(el),
    element_text: getClickText(el),
    location: getLocation(el),
    page_path: window.location.pathname,
    page_url: window.location.href,
  };

  if (moduleEl?.dataset.module) {
    params.module = moduleEl.dataset.module;
  }
  if (moduleEl?.dataset.moduleIndex != null) {
    params.module_index = Number(moduleEl.dataset.moduleIndex);
  }
  if (el.id) {
    params.element_id = el.id;
  }
  if (trackEl) {
    applyCustomParams(trackEl, params);
  }

  trackGAEvent(trackEl?.dataset.track || INTERACTION_EVENT, params);
}
